import { Outlet, createRootRoute } from '@tanstack/react-router'
import { Suspense, lazy } from 'react'
import type { JSX } from 'react'

import { NavigationProgress } from '@/components/layout/navigation-progress'
import { env } from '@/lib/env'

// Carga lazy: en producción el tree-shaking elimina este import completamente.
// En develop se carga como chunk separado después del render inicial.
const TanStackRouterDevtools =
  env.VITE_ENVIRONMENT === 'develop'
    ? lazy(() =>
        import('@tanstack/react-router-devtools').then((m) => ({
          default: m.TanStackRouterDevtools,
        })),
      )
    : null

export const Route = createRootRoute({
  component: RootLayout,
  errorComponent: RootError,
})

function RootLayout(): JSX.Element {
  return (
    <>
      <NavigationProgress />
      <Outlet />
      {TanStackRouterDevtools !== null && (
        <Suspense>
          <TanStackRouterDevtools position="bottom-right" />
        </Suspense>
      )}
    </>
  )
}

function RootError({ error }: { error: unknown }): JSX.Element {
  const message = error instanceof Error ? error.message : 'Error inesperado'
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <p className="text-destructive font-medium">Algo salió mal</p>
        <p className="text-muted-foreground mt-1 text-sm">{message}</p>
      </div>
    </div>
  )
}
